<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col :span="16">
                <span class="cs-title">真留学员列表</span>
              </el-col>
              <el-col v-if="!readonly" :span="8" class="text-right">
                <el-button type="primary" @click="onAdd" size="medium">报名注册新学员</el-button>
              </el-col>
            </el-row>
            <el-row class="margin-top-10">
              <el-col :span="4">
                <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search" v-model.trim="searchCondition.phone"
                  @keyup.enter.native="onSearchConditionChanged()"></el-input>
              </el-col>
              <el-col :span="4">
                <el-select placeholder="所有大学" filterable v-model="searchCondition.universityId" size="medium" class="margin-left-20px">
                  <el-option v-for="item in universityList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select placeholder="所有渠道" filterable v-model="searchCondition.channelId" size="medium" class="margin-left-20px">
                  <el-option v-for="item in channelList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" class="cs-saleQuery-buttons">
                <el-button size="medium" type="primary" class="margin-left-20px" @click="onSearchConditionChanged()">搜索</el-button>
              </el-col>
            </el-row>
            <el-row class="grid-content">
              <pagination v-loading="isLoading" :data="listData" :option="paginationOption" @loadData="onLoadList" @pageSizeChange="pageSizeChange"
                @currentPageChange="currentPageChange" @edit="onEdit"></pagination>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog center title="注册账号" :close-on-click-modal="false" width="700px" :visible.sync="dialogVisible" top="3vh">
      <studentregisterEditor ref="studentregister-editor" :dataIn="registerData" :isStudyAbroad="true" @closeDialog="onStudentRegisterEditorClose" @saveSuccess="onStudentRegisterEditorSaveSuccess">
      </studentregisterEditor>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
/deep/ body .el-table .el-table-header th {
  height: 30px;
  padding: 5px 0px;
  color: #909399 !important;
  background-color: #fff !important;
}

.cs-contentContainer {
  .grid-content {
    margin-top: 15px;
    /deep/ .el-table .el-table-header th {
      height: 30px;
      padding: 5px 0px;
      color: #909399 !important;
      background-color: #fff !important;
    }
  }
}
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import studentregisterEditor from "../../components/common/studentRegisterEditor";

import {
  getChannelList,
  getStudentList,
} from "../../service/studyAbroad.service";
import { getUniversities } from "../../service/common.service";

export default {
  data() {
    return {
      readonly: this.USERMANAGER.isSAAssistant,
      pageSize: 20,
      currentPageNumber: 1,
      isLoading: false,
      paginationOption: {},
      dialogVisible: false,
      listData: {},
      universityList: [
        {
          Key: "",
          Value: "所有学校",
        },
      ],
      channelList: [
        {
          Id: "",
          Name: "所有渠道",
        },
      ],
      searchCondition: {
        phone: "",
        universityId: "",
        channelId: "",
      },
      registerData:{}
    };
  },
  components: {
    navigator,
    pagination,
    studentregisterEditor,
  },
  computed: {},
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: true,
      hasAddButton: false,
      addButtonText: "",
      editButtonText: "查看详情",
    };
    getUniversities().then((result) => {
      if (!!result && result.success) {
        this.universityList = this.universityList.concat(result.data);
      }
    });
    getChannelList().then((result) => {
      if (!!result && result.success) {
        this.channelList = this.channelList.concat(result.data);
      }
    });
    this.init();
  },
  methods: {
    init() {
      this.search();
    },
    onStudentRegisterEditorClose() {
      this.dialogVisible = false;
    },
    onStudentRegisterEditorSaveSuccess(data) {
      if (this.USERMANAGER.isSANormal && data && data.user && data.user.Name){
        this.searchCondition.phone = data.user.Name;
      }
      this.search();
    },
    onSearchConditionChanged() {
      this.search();
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.loadListData(pageData);
    },
    loadListData(pageData) {
      this.isLoading = true;
      getStudentList(pageData)
        .then((result) => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      this.currentPageNumber = pageNumber;
      let additionalFilter = {
        UniversityId: this.searchCondition.universityId,
        ChannelId: this.searchCondition.channelId,
      };

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.searchCondition.phone,
        additionalFilter: additionalFilter,
      };
      return pageData;
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    onEdit(index, row) {
      let navList = JSON.stringify([{
        path: this.$route.path
      }]);

      this.$router.push({
        path: "/studyAbroad/studentServiceList",
        query: {
          studentId: row.StudentId,
          navList: this.$cryptoJS.enc.Base64.encode(navList),
        },
      });
    },
    onAdd() {
      this.registerData = {};
      this.dialogVisible = true;
    },
    onSaveSuccess() {
      this.search(this.currentPageNumber);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/studyAbroad/studentList.vue